/*eslint-disable*/
import React, { useEffect, useState } from "react";
import db from "../../../db"

// reactstrap components
import {
    Button,
    Input,
    Media,
    Row,
    Col,
    Form,
    FormGroup,
    Card,
} from "reactstrap";
import Select from "react-select";

// core components
import ImageUpload from "../../UploadImages/ImageUpload"
import DragDrop from "../../UploadImages/DragDrop"
import { handleUpload } from "../../UploadImages/HandleUpload"

function EventForm({ categoryOptions, selectedEvent, setSelectedEvent, flag, setSearchResults, deleted, setDeleted }) {

    const [eventId, setEventId] = useState("")
    const [category, setCategory] = useState(null)
    const [caption, setCaption] = useState("")
    const [description, setDescription] = useState("")
    const [isDisplayed, setIsDisplayed] = useState("")
    const [pictures, setPictures] = useState([])
    const [progress, setProgress] = useState(0)

    // Disable buttons when creating/editing
    const [disabled, setDisabled] = useState(false)

    const reset = () => {
        setEventId("")
        setCategory(null)
        setCaption("")
        setDescription("")
        setIsDisplayed("")
        setPictures([])
        setProgress(0)
        setSelectedEvent(null)
        setDeleted([])
        setSearchResults([])
        setDisabled(false)
    }

    // Set Input values to Selected Event's data
    useEffect(() => {
        if (selectedEvent) {
            setEventId(selectedEvent.id)
            setCategory({ value: selectedEvent.category, label: selectedEvent.categoryName })
            setCaption(selectedEvent.caption)
            setDescription(selectedEvent.description)
            setIsDisplayed(selectedEvent.isDisplayed)
            setPictures(selectedEvent.pictures)
        }
    }, [selectedEvent, flag])

    const upload = async (taskFunction, task) => {
        const convert = { pictures: deleted }
        setTimeout(async () => {
            deleted.length > 0 && await db.Events.removeEventImages(convert)
        }, 500);

        let docRef = ""
        if (task === "create") {
            docRef = await db.Events.createRef().id
        }
        else {
            docRef = eventId
        }
        const directory = `portfolio/${category.value}/${docRef}`
        handleUpload({ pictures, setProgress, docRef, taskFunction, task, directory })
    }

    const create = ({ urls, docRef }) => {
        db.Events.update({ id: docRef, category: category.value, caption, description, isDisplayed: isDisplayed, pictures: urls, categoryName: category.label })
        reset()
    }

    const edit = async ({ urls }) => {
        await db.Events.update({ id: eventId, category: category.value, caption, description, isDisplayed: isDisplayed, pictures: urls, categoryName: category.label })
        reset()
    }

    // Validation
    const valid = () =>
        category &&
        pictures.length > 0 &&
        !disabled

    const validEdit = () =>
        !valid()

    return (
        <Card className="section-dark-blue">
            <Media style={{ padding: "2%" }}>
                <Form className="form" style={{ minWidth: "100%", minHeight: "100%" }}>
                    <Media body>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <ImageUpload
                                        progress={progress}
                                        valid={valid}
                                        maxNumber={50}
                                        setPictures={setPictures}
                                        pictures={pictures}
                                        deleted={deleted}
                                        setDeleted={setDeleted}
                                        disabled={disabled}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12" >
                                {
                                    pictures.length === 0 &&
                                    <FormGroup>
                                        <DragDrop setPictures={setPictures} />
                                    </FormGroup>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Input
                                        className="border-input"
                                        placeholder="Caption"
                                        type="text"
                                        onChange={(event) => setCaption(`${event.target.value}`)}
                                        value={caption}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Input
                                        className="border-input"
                                        placeholder="Description"
                                        type="text"
                                        onChange={(event) => setDescription(event.target.value)}
                                        value={description}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup >
                                    <Select
                                        className="react-select react-select-default border-input"
                                        name="category"
                                        value={category}
                                        onChange={(value) => setCategory(value)}
                                        options={categoryOptions}
                                        placeholder={category && category.label || "Choose Category"}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Select
                                        className="react-select react-select-default border-input"
                                        name="category"
                                        value={isDisplayed}
                                        onChange={(value) => setIsDisplayed(value.value)}
                                        options={[{ value: true, label: "TRUE" }, { value: false, label: "FALSE" }]}
                                        placeholder={isDisplayed.toString().toLocaleUpperCase() || "Display Event?"}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="media-footer">
                            <Row>
                                <Col lg="8" xs="6" md="8">
                                    {
                                        !eventId ?
                                            <Button
                                                className="btn-round mr-1"
                                                color="success"
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    upload(create, "create")
                                                    setDisabled(true)
                                                }}
                                                disabled={!valid()}
                                                style={{ minWidth: "100%" }}
                                            >
                                                Create
                                            </Button>
                                            :
                                            <Button
                                                className="btn-round mr-1"
                                                color="success"
                                                type="button"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    upload(edit, "edit")
                                                    setDisabled(true)
                                                }}
                                                disabled={validEdit()}
                                                style={{ minWidth: "100%" }}
                                            >
                                                Edit
                                            </Button>
                                    }
                                </Col>
                                <Col lg="4" xs="6" md="4">
                                    <Button
                                        className="btn-round mr-1"
                                        color="danger"
                                        type="button"
                                        onClick={reset}
                                        style={{ minWidth: "100%" }}
                                        disabled={disabled}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Media>
                </Form>
            </Media>
        </Card>
    );
}

export default EventForm;
